import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import { Zap, Menu, X } from "lucide-react";

/* SalesHeader — Header fixo com badge de urgência pulsante e CTA com preço */
export const SalesHeader = () => {
  const [scrolled, setScrolled] = useState(false);
  const [showUrgency, setShowUrgency] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
      setShowUrgency(window.scrollY < 80);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleCTAClick = () => {
    window.open("https://pay.kiwify.com.br/bGcYJms", "_blank", "noopener,noreferrer");
  };

  return (
    <>
      {/* Barra de urgência topo */}
      <AnimatePresence>
        {showUrgency && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="fixed top-0 left-0 right-0 z-[60] overflow-hidden"
          >
            <div className="bg-destructive/90 backdrop-blur-sm text-destructive-foreground text-xs font-semibold text-center py-2 px-4 flex items-center justify-center gap-2">
              <motion.span
                animate={{ opacity: [1, 0.5, 1] }}
                transition={{ repeat: Infinity, duration: 1.5 }}
              >
                <Zap className="w-3.5 h-3.5 inline-block mr-1" />
              </motion.span>
              <span className="hidden sm:inline">Oferta de lançamento — Preço especial por tempo limitado</span>
              <span className="sm:hidden">Oferta de lançamento — Preço especial</span>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Header principal */}
      <motion.header
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        style={{ top: showUrgency ? "32px" : "0px" }}
        className={`fixed left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? "bg-background/90 backdrop-blur-md border-b border-border shadow-lg"
            : "bg-background/70 backdrop-blur-sm border-b border-white/5"
        }`}
      >
        <div className="container mx-auto px-4 h-14 sm:h-16 flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-2 sm:gap-3">
            <div className="bg-gradient-to-br from-accent to-primary rounded-xl w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center text-accent-foreground font-bold text-xs sm:text-sm shrink-0">
              JO
            </div>
            <div className="hidden xs:block">
              <span className="font-semibold text-foreground text-xs sm:text-sm block leading-tight">
                Jornada Oncológica
              </span>
              <span className="text-muted-foreground text-xs hidden sm:block">na Prática</span>
            </div>
          </div>

          {/* Direita: preço + CTA */}
          <div className="flex items-center gap-2 sm:gap-3">
            <div className="hidden lg:flex flex-col items-end">
              <span className="text-muted-foreground text-xs line-through">R$ 97,00</span>
              <span className="text-accent font-bold font-mono text-sm">R$ 77,90</span>
            </div>
            <motion.button
              onClick={handleCTAClick}
              className="bg-accent hover:bg-accent/90 text-accent-foreground text-xs sm:text-sm font-bold px-3 sm:px-4 py-2 rounded-xl transition-colors whitespace-nowrap"
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
              animate={{
                boxShadow: [
                  "0 0 0 0 rgba(104,211,145,0)",
                  "0 0 12px 3px rgba(104,211,145,0.3)",
                  "0 0 0 0 rgba(104,211,145,0)",
                ],
              }}
              transition={{ boxShadow: { repeat: Infinity, duration: 2.8 } }}
            >
              <span className="hidden sm:inline">Acessar agora →</span>
              <span className="sm:hidden">Acessar →</span>
            </motion.button>
          </div>
        </div>
      </motion.header>

      {/* Spacer dinâmico para o conteúdo não ficar atrás do header */}
      <div style={{ height: showUrgency ? "calc(3.5rem + 32px)" : "3.5rem" }} className="sm:hidden" />
      <div style={{ height: showUrgency ? "calc(4rem + 32px)" : "4rem" }} className="hidden sm:block" />
    </>
  );
};
